module.exports = __webpack_public_path__ + "img/personal_student_wrong_reson.15f305c6.svg";